var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"site-footer"},[_c('span',[_vm._v("© 易尤特集团")]),_c('span',[_vm._v("©2003-2022 All Rights Reserved "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/index"}},[_vm._v("ICP备17027634号-2")])])])
}]

export { render, staticRenderFns }